module.exports = __webpack_public_path__ + "img/contract.b66ef0dd.jpg";